import React, { useState, useEffect } from "react";

const Lan = () => {
    const [lanData, setLanData] = useState(null);
    const [isApiSuccess, setIsApiSuccess] = useState(false);

    useEffect(() => {
        fetch("http://192.168.2.233:8080/edge/diagnostic/auto?type=Ethernet")
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error("Error");
            })
            .then((data) => {
                setLanData(data);
                setIsApiSuccess(true);
            })
            .catch((error) => {
                console.error(" error fetching the  data!", error);
                setIsApiSuccess(false);
            });
    }, []);

    return (
        <div className="component-box">
            <div className="inline-box">
                <img src="img/lan-blue.png" alt="lan" className="icon" />
                <span>LANポート</span>
            </div>
            <div className="table-box">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>eth0</th>
                            <th>eth1</th>
                            <th>br0</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <p>status: UP</p>
                                <p>ip: 192.168.12.1</p>
                                <p>ping: OK</p>
                            </td>
                            <td>
                                <p>status: UP</p>
                                <p></p>
                                <p>ping: OK</p>
                            </td>
                            <td>
                                <p>status: UP</p>
                                <p>ip: 192.168.12.1</p>

                                <p>ping: OK</p>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <span className="info-message"><img src="img/info.png" alt="info" />すべての LAN ポートの接続を確認してください。</span>
                {/* <div className="box-wrapper failed-wrapper">
                    <span>LAN ポートの接続を確認できません。</span>
                    <div className="two-button-box">
                        <button className="retry">リトライ</button>
                        <button className="skip">スキップ</button>
                    </div>
                </div> */}
            </div>

            {/*<div className="table-box">
             {isApiSuccess && lanData ? (
             
                <table className="cpu-table">
                    <thead>
                        <tr>
                            <th>eth0</th>
                            <th>eth1</th>
                            <th>br0</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <p>status: {lanData.eth0.status}</p>
                                <p>ip: {lanData.eth0.ip}</p>
                                <p>ping: {lanData.eth0.ping}</p>
                            </td>
                            <td>
                                <p>status: {lanData.eth1.status}</p>
                                <p>ip: {lanData.eth1.ip || "N/A"}</p>
                                <p>ping: {lanData.eth1.ping}</p>
                            </td>
                            <td>
                                <p>status: {lanData.br0.status}</p>
                                <p>ip: {lanData.br0.ip}</p>
                                <p>ping: {lanData.br0.ping}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                
            ) : (
                <p>Loading...</p>
            )} </div>*/}
        </div >
    );
};

export default Lan;
